(() => {
  const money = (cents, currency='CLP') => currency === 'CLP'
    ? '$' + Math.round(cents / 100).toLocaleString('es-CL')
    : new Intl.NumberFormat('es-CL',{style:'currency',currency}).format(cents/100);
  function initPacks(root=document) {
    root.querySelectorAll('[data-newen-packs]').forEach(selector => {
      if(selector.dataset.initialized) return;
      selector.dataset.initialized='true';
      let variants;
      try {variants=JSON.parse(selector.querySelector('[data-newen-variants]').textContent);} catch (_) {return;}
      let variant=variants.find(v=>String(v.id)===selector.dataset.variantId)||variants[0];
      const options=[...selector.querySelectorAll('[data-newen-pack]')];
      const quantity=selector.querySelector('[data-newen-quantity]');
      const formId=selector.dataset.formId;
      function update(){
        if(!variant) return;
        let selected=options.find(o=>o.querySelector('input').checked)||options[0];
        options.forEach(option=>{
          const q=Math.max(1,parseInt(option.dataset.quantity)||1), regular=Number(variant.price)*q;
          const discount=Math.min(80,Math.max(0,Number(option.dataset.discount)||0));
          const fixed=Number(option.dataset.fixed)||0;
          const total=Math.min(regular,Math.max(0,option.dataset.pricing==='fixed_total'&&fixed>0?fixed:Math.round(regular*(1-discount/100))));
          const saving=regular-total;
          option.querySelector('[data-newen-total]').textContent=money(total,selector.dataset.currency);
          const old=option.querySelector('[data-newen-regular]');old.textContent=money(regular,selector.dataset.currency);old.hidden=saving<=0;
          option.querySelector('[data-newen-saving]').textContent=saving>0?'Ahorras '+money(saving,selector.dataset.currency):'Precio normal';
          option.classList.toggle('is-selected',option===selected);
          if(option===selected){
            quantity.value=String(q);
            selector.querySelector('[data-newen-pack-property]').value=option.dataset.label;
            selector.querySelector('[data-newen-total-property]').value=money(total,selector.dataset.currency);
            selector.querySelector('[data-newen-pack-summary]').textContent=q+(q===1?' unidad':' unidades')+' · '+money(total,selector.dataset.currency);
            quantity.dispatchEvent(new Event('change',{bubbles:true}));
          }
        });
      }
      selector.addEventListener('change',event=>{if(event.target.type==='radio')update();});
      function bindForm(){
        const form=document.getElementById(formId);const id=form?.querySelector('input[name="id"]');
        if(id&&!id.dataset.newenWatched){id.dataset.newenWatched='true';id.addEventListener('change',()=>{variant=variants.find(v=>String(v.id)===id.value);update();});}
        if(form&&!form.dataset.newenPackBound){form.dataset.newenPackBound='true';form.addEventListener('submit',update,true);}
      }
      bindForm(); update();
      if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined'){
        const unsubscribe=subscribe(PUB_SUB_EVENTS.variantChange,event=>{
          if(String(event.data.sectionId)!==selector.dataset.sectionId)return;
          if(!selector.isConnected){unsubscribe();return;}
          variant=event.data.variant;bindForm();update();
        });
      }
    });
  }
  function initReviews(root=document){
    root.querySelectorAll('[data-product-reviews]').forEach(reviews=>{
      const count=Number(reviews.dataset.reviewCount)||0, rating=Number(reviews.dataset.reviewRating)||0;
      document.querySelectorAll('.newen-review-link').forEach(link=>{link.textContent=count>0?'★ '+rating.toFixed(1)+' · '+count+' opiniones ↓':'Ver opiniones de clientes ↓';});
    });
  }
  function init(){initPacks();initReviews();}
  document.addEventListener('DOMContentLoaded',init);
  document.addEventListener('shopify:section:load',init);
  document.addEventListener('product-info:loaded',init);
})();

/* NEWEN: comunas dependientes de region, conservando la lista permitida de Releasit. */
(() => {
  const regions = {
  "AP": "Arica,Camarones,Putre,General Lagos",
  "TA": "Iquique,Alto Hospicio,Pozo Almonte,Camiña,Colchane,Huara,Pica",
  "AN": "Antofagasta,Mejillones,Sierra Gorda,Taltal,Calama,Ollagüe,San Pedro de Atacama,Tocopilla,María Elena",
  "AT": "Copiapó,Caldera,Tierra Amarilla,Chañaral,Diego de Almagro,Vallenar,Alto del Carmen,Freirina,Huasco",
  "CO": "La Serena,Coquimbo,Andacollo,La Higuera,Paihuano,Vicuña,Illapel,Canela,Los Vilos,Salamanca,Ovalle,Combarbalá,Monte Patria,Punitaqui,Río Hurtado",
  "VS": "Valparaíso,Casablanca,Concón,Puchuncaví,Quintero,Viña del Mar,Los Andes,Calle Larga,Rinconada,San Esteban,La Ligua,Cabildo,Papudo,Petorca,Zapallar,Quillota,La Calera,Hijuelas,La Cruz,Nogales,San Antonio,Algarrobo,Cartagena,El Quisco,El Tabo,Santo Domingo,San Felipe,Catemu,Llaillay,Panquehue,Putaendo,Santa María,Limache,Quilpué,Villa Alemana,Olmué",
  "RM": "Santiago,Cerrillos,Cerro Navia,Conchalí,El Bosque,Estación Central,Huechuraba,Independencia,La Cisterna,La Florida,La Granja,La Pintana,La Reina,Las Condes,Lo Barnechea,Lo Espejo,Lo Prado,Macul,Maipú,Ñuñoa,Pedro Aguirre Cerda,Peñalolén,Providencia,Pudahuel,Quilicura,Quinta Normal,Recoleta,Renca,San Joaquín,San Miguel,San Ramón,Vitacura,Puente Alto,Pirque,San José de Maipo,Colina,Lampa,Tiltil,San Bernardo,Buin,Calera de Tango,Paine,Melipilla,Alhué,Curacaví,María Pinto,San Pedro,Talagante,El Monte,Isla de Maipo,Padre Hurtado,Peñaflor",
  "LI": "Rancagua,Codegua,Coinco,Coltauco,Doñihue,Graneros,Las Cabras,Machalí,Malloa,Mostazal,Olivar,Peumo,Pichidegua,Quinta de Tilcoco,Rengo,Requínoa,San Vicente,Pichilemu,La Estrella,Litueche,Marchihue,Navidad,Paredones,San Fernando,Chépica,Chimbarongo,Lolol,Nancagua,Palmilla,Peralillo,Placilla,Pumanque,Santa Cruz",
  "ML": "Talca,Constitución,Curepto,Empedrado,Maule,Pelarco,Pencahue,Río Claro,San Clemente,San Rafael,Cauquenes,Chanco,Pelluhue,Curicó,Hualañé,Licantén,Molina,Rauco,Romeral,Sagrada Familia,Teno,Vichuquén,Linares,Colbún,Longaví,Parral,Retiro,San Javier,Villa Alegre,Yerbas Buenas",
  "NB": "Chillán,Bulnes,Cobquecura,Coelemu,Coihueco,Chillán Viejo,El Carmen,Ninhue,Ñiquén,Pemuco,Pinto,Portezuelo,Quillón,Quirihue,Ránquil,San Carlos,San Fabián,San Ignacio,San Nicolás,Treguaco,Yungay",
  "BI": "Concepción,Coronel,Chiguayante,Florida,Hualqui,Lota,Penco,San Pedro de la Paz,Santa Juana,Talcahuano,Tomé,Hualpén,Lebu,Arauco,Cañete,Contulmo,Curanilahue,Los Álamos,Tirúa,Los Ángeles,Antuco,Cabrero,Laja,Mulchén,Nacimiento,Negrete,Quilaco,Quilleco,San Rosendo,Santa Bárbara,Tucapel,Yumbel,Alto Biobío",
  "AR": "Temuco,Carahue,Cunco,Curarrehue,Freire,Galvarino,Gorbea,Lautaro,Loncoche,Melipeuco,Nueva Imperial,Padre Las Casas,Perquenco,Pitrufquén,Pucón,Saavedra,Teodoro Schmidt,Toltén,Vilcún,Villarrica,Cholchol,Angol,Collipulli,Curacautín,Ercilla,Lonquimay,Los Sauces,Lumaco,Purén,Renaico,Traiguén,Victoria",
  "LR": "Valdivia,Corral,Lanco,Los Lagos,Máfil,Mariquina,Paillaco,Panguipulli,La Unión,Futrono,Lago Ranco,Río Bueno",
  "LL": "Puerto Montt,Calbuco,Cochamó,Fresia,Frutillar,Los Muermos,Llanquihue,Maullín,Puerto Varas,Castro,Ancud,Chonchi,Curaco de Vélez,Dalcahue,Puqueldón,Queilén,Quellón,Quemchi,Quinchao,Osorno,Puerto Octay,Purranque,Puyehue,Río Negro,San Juan de la Costa,San Pablo,Chaitén,Futaleufú,Hualaihué,Palena",
  "AI": "",
  "MA": ""
};
  const normalize = value => String(value).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
  const allowed = Object.fromEntries(Object.entries(regions).map(([code, names]) => [code, new Set(names.split(',').filter(Boolean).map(normalize))]));
  const bound = new WeakMap();
  function install() {
    document.querySelectorAll('select[name="province_country_field"]').forEach(region => {
      const form = region.closest('form');
      const city = form?.querySelector('select[name="additionals_dropdown_input_city"]');
      if (!city || bound.get(city) === region) return;
      const original = Array.from(city.options).filter(option => option.value).map(option => option.cloneNode(true));
      if (!original.length) return;
      bound.set(city, region);
      city.required = true;
      region.required = true;
      function update(reset) {
        const previous = reset ? '' : city.value;
        const set = allowed[region.value];
        const options = original.filter(option => set?.has(normalize(option.value)));
        const placeholder = new Option(!region.value ? 'Primero selecciona tu región' : options.length ? 'Selecciona tu comuna' : 'Sin cobertura en esta región', '');
        city.replaceChildren(placeholder, ...options.map(option => option.cloneNode(true)));
        city.value = options.some(option => option.value === previous) ? previous : '';
        city.disabled = !region.value || !options.length;
        region.setCustomValidity(region.value && !options.length ? 'No tenemos cobertura en esta región. Selecciona otra región.' : '');
        if (reset || previous !== city.value) {
          city.dispatchEvent(new Event('input', { bubbles: true }));
          city.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      region.addEventListener('change', () => update(true));
      update(false);
    });
  }
  let queued = false;
  const observer = new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; install(); });
  });
  function start() { install(); observer.observe(document.body, { childList: true, subtree: true }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
